import React, { useEffect, useRef } from 'react';
import './ComparisonSection.css';

const timelinePairs = [
  {
    p: (<span className="content-title p1"><span style={{ color: 'red' }}>✘</span> <strong>Rejections</strong> Generic resumes fail ATS filters</span>),
    s: (<span className="content-title s1"><span className="green-check">✔</span> <strong>ATS-Friendly CVs</strong> Instantly build optimized resumes that pass recruiter filters</span>)
  },
  {
    p: (<span className="content-title p2"><span style={{ color: 'red' }}>✘</span> <strong>Low Confidence</strong> practice with real-time interviews</span>),
    s: (<span className="content-title s2"><span className="green-check">✔</span> <strong>Real-Time Mock Interviews</strong> Practice with AI-driven interview simulations & expert feedback</span>)
  },
  {
    p: (<span className="content-title p3"><span style={{ color: 'red' }}>✘</span> <strong>Unproven Skills</strong> Employers may question your expertise</span>),
    s: (<span className="content-title s3"><span className="green-check">✔</span> <strong>Skill Tests & Certificates</strong> Validate your expertise and showcase results to employers</span>)
  },
  {
    p: (<span className="content-title p4"><span style={{ color: 'red' }}>✘</span> <strong>Outdated Learning</strong> Not aligned with real-world jobs</span>),
    s: (<span className="content-title s4"><span className="green-check">✔</span> <strong>Job-Ready Courses</strong> Learn trending tech skills (AI, Data, Cloud, Cybersecurit, Digital Marketing) with industry projects</span>)
  }
];

export default function ComparisonSection() {
  const sectionRef = useRef();

  // Animate SVG lines when section comes into view
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const timeline = section.querySelector('.comparison-timeline');
    const paths = section.querySelectorAll('.connector-path');
    paths.forEach(path => {
      const length = path.getTotalLength();
      path.style.strokeDasharray = length;
      path.style.strokeDashoffset = length;
    });

    const observer = new window.IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          paths.forEach(path => {
            path.style.strokeDashoffset = 0;
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    if (timeline) observer.observe(timeline);

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="comparison-section">
      <div className="container">
        <header className="header-content">
          <h1 className="header-title">Say goodbye to job struggles</h1>
          {/* <p className="header-subtitle">
            Our mission is simple — empower ambitious learners and job seekers to break through hiring barriers. We’ve identified the real challenges in today’s job market and built dedicated tools that give you a strategic edge.
          </p> */}
        </header>
        <div className="column-headers">
          <div className="header-left">Turn Challenges into Career Wins:</div>
          <div></div>
          <div className="header-right">We help you achieve:</div>
        </div>
        <div id="comparison-timeline" className="comparison-timeline">
          {timelinePairs.map((pair, idx) => (
            <div className="timeline-pair" key={idx}>
              <div className="content-wrapper content-problem">
                {pair.p}
              </div>
              <svg className="connector-svg" viewBox="0 0 100 60" preserveAspectRatio="none">
                <path className="connector-path" d="M 0,30 C 50,0 50,60 100,30"></path>
              </svg>
              <div className="content-wrapper content-solution">
                {pair.s}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
